import {
  AutomationActionHttpPostDenormalized,
  IAutomationActionTemplateHttpPost
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryHttpPost = ({
  a,
  expTpl,
  def
}: {
  a: IAutomationActionTemplateHttpPost | AutomationActionHttpPostDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  const target = a.requestUrl || 'an endpoint';
  console.log('requestUrl', `'${target}'`);
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t('Make a post request to {{ target }}', {
            target
          })}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
